import React from 'react';
import { Card, CardBody, Container, Row, Col } from 'reactstrap';

export default function AccessDenied() {
  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col lg="8" md="10">
          <Card className="border-0 shadow">
            <CardBody className="p-5 text-center">
              <div className="mb-4">
                <i className="ni ni-lock-circle-open" style={{fontSize: '64px', color: '#fb6340'}}></i>
              </div>

              <h2 className="mb-4" style={{color: '#32325d', fontWeight: 600}}>
                Access Restricted
              </h2>

              <p className="lead text-muted mb-4" style={{fontSize: '1.1rem', lineHeight: '1.8'}}>
                You do not have access to the Gifts that Give application.
              </p>

              <div className="bg-gradient-primary rounded p-4 mb-4" style={{background: 'linear-gradient(87deg, #5e72e4 0, #825ee4 100%)'}}>
                <p className="text-white mb-2" style={{fontSize: '1rem'}}>
                  <strong>Need Access?</strong>
                </p>
                <p className="text-white mb-3" style={{opacity: 0.9}}>
                  Please reach out to our support team for assistance.
                </p>
                <a
                  href="mailto:mts@alsac.stjude.org"
                  className="btn btn-white btn-sm"
                  style={{fontWeight: 500}}
                >
                  <i className="ni ni-email-83 mr-2"></i>
                  Contact: mts@alsac.stjude.org
                </a>
              </div>

              <p className="text-muted small mb-0" style={{fontSize: '0.875rem'}}>
                Our team will respond to your request as soon as possible.
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
